import classnames from 'classnames';
import IconNext from './icon_next.svg?react';
import IconPrev from './icon_prev.svg?react';
import s from './index.module.scss';

export const SliderNavigation = ({
  onNext,
  onPrev,
  isBeginning = false,
  isEnd = false,
}) => (
  <div className={s.controls}>
    <button
      type="button"
      className={classnames(s.prev, isBeginning && 'disabled')}
      onClick={() => onPrev()}
    >
      <IconPrev />
    </button>
    <button
      type="button"
      className={classnames(s.next, isEnd && 'disabled')}
      onClick={() => onNext()}
    >
      <IconNext />
    </button>
  </div>
);
